import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Form, Button, Col, Container, Row } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';

import FooterComponen from '../../components/footer';
import BannerParkingMedia from '../../asses/img/Banner Parking Media.png';

const FormParkingMedia = () => {
  const [loading, setLoading] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const downloadKit = async (data) => {
    setShowLoading(true);
    try {
      const responseSendKit = await axios.post(
        `https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/ContactCategory/createRequestMedia`,
        {
          name: data.name,
          email: data.email,
          phone: data.phone,
          company: data.company,
        }
      );

      console.log(responseSendKit);

      if (responseSendKit.data.status) {
        const response = await axios.get(responseSendKit.data.url_kit, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `${responseSendKit.data.name_document}`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(blobUrl);
        toast.success('Descarga exitosa');
        reset();
        setShowLoading(false);
      } else {
        toast.error('Hubo un error en la descarga del kit');
        setShowLoading(false);
      }
    } catch (error) {
      setShowLoading(false);
      if (error.response) {
        toast.error('Algo salio mal descargando el kit...');
        console.log(error.response);
      } else if (error.request) {
        toast.error('Algo salio mal descargando el kit...');
        console.log(error.request);
      } else {
        toast.error('Algo salio mal descargando el kit...');
        console.log('Error', error.message);
      }
    }
  };

  return loading ? (
    <div className="cargando">
      <div class="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <Container>
        <Row className="row-media" style={{ textAlign: 'start' }}>
          <img
            style={{ width: '100%' }}
            src={BannerParkingMedia}
            alt="Banner Parking Media"
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <h2 className="texto-titulo" style={{ paddingBottom: '1rem' }}>
              Descarga el Media Kit - Parking Media
            </h2>
            <form onSubmit={handleSubmit(downloadKit)}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Nombre</Form.Label>
                <Controller
                  name="name"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'El campo es obligatorio',
                    },
                  }}
                  defaultValue=""
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Control
                      type="text"
                      placeholder="Escribe tu nombre"
                      onBlur={onBlur}
                      onChange={(value) => {
                        onChange(value);
                      }}
                      value={value}
                    />
                  )}
                />
                {errors.name && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    El nombre es obligatorio
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group controlId="formBasicEmail">
                <Form.Label>Correo</Form.Label>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'El correo es obligatorio',
                    },
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: 'Correo inválido',
                    },
                  }}
                  defaultValue=""
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Control
                      type="text"
                      placeholder="Escribe tu correo"
                      onBlur={onBlur}
                      onChange={(value) => {
                        onChange(value);
                      }}
                      value={value}
                    />
                  )}
                />
                {errors.email && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    {errors.email.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group controlId="formPhone">
                <Form.Label>Teléfono</Form.Label>
                <Controller
                  name="phone"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'El teléfono es obligatorio',
                    },
                    pattern: {
                      value: /^3\d{9}$/,
                      message: 'Debe tener 10 dígitos y comenzar con 3',
                    },
                  }}
                  defaultValue=""
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Control
                      type="text"
                      placeholder="Escribe tu teléfono"
                      onBlur={onBlur}
                      onChange={(e) => onChange(e.target.value)}
                      value={value}
                    />
                  )}
                />
                {errors.phone && (
                  <Form.Text className="error">
                    {errors.phone.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group controlId="formBasicEmail">
                <Form.Label>Empresa</Form.Label>
                <Controller
                  name="company"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'El campo es obligatorio',
                    },
                  }}
                  defaultValue=""
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Form.Control
                      type="text"
                      placeholder="Escribe tu nombre"
                      onBlur={onBlur}
                      onChange={(value) => {
                        onChange(value);
                      }}
                      value={value}
                    />
                  )}
                />
                {errors.company && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    La empresa es obligatoria
                  </Form.Text>
                )}
              </Form.Group>

              <div className="text-center">
                {showLoading ? (
                  <div className="container-sniper"></div>
                ) : (
                  <Button
                    className="btn-borde-verde mt-4"
                    size="sm"
                    type="submit"
                  >
                    Descargar Kit
                  </Button>
                )}
              </div>
            </form>
          </div>
        </Row>
      </Container>
      <FooterComponen />
    </>
  );
};

export default FormParkingMedia;
